import {
  HappinessArea,
  HappinessDesc,
  HappinessGraph,
  HappinessGraphBG,
  HappinessGraphMarker,
  HappinessUpdatedAt,
  HappinessValueRow,
} from 'features/hive/ui/HiveBody/styles.ts';
import {HappinessSemicircle} from 'shared/ui/icons/happinessSemicircle.tsx';
import HappinessMarker from 'shared/ui/icons/happinessMarker.tsx';
import {Tooltip} from '@atomaro/ui-kit';
import {TooltipIcon} from 'shared/ui/icons/tooltipIcon.tsx';
import {HappyIcon} from 'shared/ui/icons/happyIcon.tsx';
import {SadIcon} from 'shared/ui/icons/sadIcon.tsx';
import {MiddleHapinessIcon} from 'shared/ui/icons/middleHapinessIcon.tsx';
import {useCurrentHiveStore} from 'entities/currentHive';
import {FC} from 'react';
import {utcToUserDate, getLastHappinessUpdate} from 'features/calendar/helpers/dates.ts';

type Props = {
  value?: number | null;
};

export const HiveBodyHappiness: FC<Props> = ({value}) => {
  const currHive = useCurrentHiveStore((s) => s.currentHive);
  const storeValue = useCurrentHiveStore((s) => s.currentHive?.happiness) || 0;
  let happinessValue = typeof value === 'number' ? value : storeValue;
  if (!happinessValue) happinessValue = 0;

  let Icon = MiddleHapinessIcon;
  if (happinessValue >= 4.8) Icon = HappyIcon;
  else if (happinessValue <= 3.5) Icon = SadIcon;
  
  const lastUpdate = getLastHappinessUpdate()
  const date = utcToUserDate(lastUpdate)
    .toLocaleDateString(undefined, {month: "2-digit", day: "2-digit"})
  const time = utcToUserDate(lastUpdate)
    .toLocaleTimeString(undefined, {timeStyle: "short"})

  return (
    <HappinessArea className={'happiness'}>
      <HappinessGraph>
        <HappinessGraphBG>
          <HappinessSemicircle />
        </HappinessGraphBG>
        <HappinessGraphMarker $value={happinessValue}>
          <HappinessMarker />
        </HappinessGraphMarker>
        <HappinessValueRow>
          <Icon />
          <h3>{happinessValue.toFixed(1)}</h3>
          <Tooltip
            onClose={function noRefCheck() {}}
            onOpen={function noRefCheck() {}}
            size="m"
            subtitle="Индекс счастья - усредненный показатель жизнедеятельности и благополучия пчел в ульях"
            trigger="click"
            variant="primary"
          >
            <TooltipIcon />
          </Tooltip>
        </HappinessValueRow>
        <HappinessDesc>Индекс счастья</HappinessDesc>
        <HappinessUpdatedAt> {`Обновлено ${date} в ${time}`} </HappinessUpdatedAt>
      </HappinessGraph>
    </HappinessArea>
  );
};
